module.exports = __webpack_public_path__ + "bangladesh.svg?d90131c16640e0a49987968dd808410a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/bangladesh.svg
// module id = 104
// module chunks = 10